<div *ngIf="orgKey" class="footer">
  <div *ngIf="!isLoading" class="pt-4 pb-4 text-center" style="background-color: #f8f9fa">
    <h5 class="mb-0">{{ organization.Name }}</h5>
    {{ organization.Address.Street }}&nbsp;{{ organization.Address.Nr }}&nbsp;{{
      organization.Address.Bus
    }}<br />
    {{ organization.Address.PostCode }}&nbsp;{{ organization.Address.Location }}
    <br />
    Ond.nr.:&nbsp;{{ organization.BTWNumber }}
    <br *ngIf="organization.Address.Website" />
    <a href="{{ organization.Address.Website }}" target="_blank">{{
      organization.Address.Website
    }}</a
    ><br *ngIf="organization.Address.Email" />
    <a href="mailto:{{ organization.Address.Email }}">{{ organization.Address.Email }}</a>
    <br /><br />
    <br /><span class="text-sm d-block" style="margin-bottom: 0.5rem">Gemaakt met</span>
    <a class="navbar-brand m-0" href="https://assistonline.eu" target="_blank">
      <img src="../../assets/img/logo-assist.png" height="40" alt="Assist." />
    </a>
  </div>
</div>
